export enum QuizLifecycleState {
  Question,
  Explanation,
  Review,
}
